<template>
    <div class="trivia-count">
        <p>{{ current }}/{{ total }}</p>
    </div>
</template>

<script>
export default {
    name: 'trivia-count',
    props: ['current', 'total']
}
</script>


<style lang="scss" scoped>
.trivia-count {
    background: #F98B02;
    height: 104px;
    position: absolute;
    right: 28px;
    top: 0;
    width: 54px;

    p {
        color: #fff;
        font-family: 'Roboto Condensed';
        font-size: 30px;
    }
}
</style>
